import { useMemo } from 'react';
import { FieldType, MyTimeTrackingQuery } from '../../__generated__/graphql';
import { mapToExtraFieldInternalValue } from '../../components/ExtraFields/extraFieldInternalValue';
import {
  extraFieldsContextParams,
  ExtraFieldContextParam,
} from '../../components/ExtraFields/types';
import { toISODateOnly } from '../../../../utils/dateUtils';

type TimeEntry = NonNullable<MyTimeTrackingQuery['me']['currentTimeEntry']>;

export const useTimeEntryExtraFieldsSetup = (entry: TimeEntry) => {
  const extraFieldValues = useMemo(
    () => (entry.extraFields ?? []).map(mapToExtraFieldInternalValue),
    [entry.extraFields],
  );

  const recordTypeName = entry.recordType?.Name ?? null;

  const contextParams: ExtraFieldContextParam[] = useMemo(
    () => [
      {
        name: extraFieldsContextParams.timeEntryEdit.day,
        type: FieldType.Date,
        value: toISODateOnly(new Date(entry.flair__Start_Datetime__c)),
      },
      {
        name: extraFieldsContextParams.timeEntryEdit.employee,
        type: FieldType.Reference,
        value: entry.flair__Employee__c,
      },
    ],
    [entry.flair__Start_Datetime__c, entry.flair__Employee__c],
  );

  return { extraFieldValues, recordTypeName, contextParams };
};
